import React from 'react';
import styles from './TransportCard.module.scss';
import DeleteTransportBtn from '../../../../../../../components/DeleteTransportBtn/DeleteTransportBtn';
import moment from 'moment';
import { ReactComponent as EditNewIcon } from '../../../../../../../resource/EditNewIcon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { setVisibleTransportForm } from '../../../../../store/actions/housingStockActions';
import { message } from 'antd';
import useTransportCheckPermit from '../../../../../../../queries/useTransportCheckPermit';
import TransportDocuments from '../../../../../../../components/TransportDocuments/TransportDocuments';
import { permitConstants } from '../../../../../../../constants/permit.constants';

const Item = ({
  transport,
  title = '',
  color = 'black',
  value = '',
  styleContent,
  ...props
}) => {
  return (
    <div
      className={styles.item}
      {...props}
    >
      <div className={styles.title}>{title}</div>
      <div
        className={styles.content}
        style={{ color, ...styleContent }}
      >
        {value}
      </div>
    </div>
  );
};

const TransportCard = ({ item, tenant, addressId, companyId, onSuccess }) => {
  const dispatch = useDispatch();

  const { mutateAsync: checkTransport } = useTransportCheckPermit();

  const { AllowTransportPermit } = useSelector(
    (store) => store.authentication.userInfo
  );

  const hasPermits = !!item?.accessInformation?.length && AllowTransportPermit;

  const handleOpenModal = async () => {
    const res = await checkTransport({ transportId: item?.transport?.id });

    if (!res?.success) {
      message.info(
        'У данного ТС есть пропуска, редактирование ТС запрещено',
        3
      );
      return;
    }

    dispatch(
      setVisibleTransportForm({
        id: item?.transport?.id,
        clientId: tenant?.id,
        addressId,
        onSuccess,
      })
    );
  };

  return (
    <div className={styles.root}>
      <div className={styles.gridBox}>
        <Item
          title="Транспортное средство"
          value={[item.transport?.brand, item.transport?.model].join(' ')}
        />
        <Item
          title="Номер"
          value={[
            ...(item?.transport?.number?.split(/(?<=\D)(?=\d)|(?<=\d)(?=\D)/) ||
              []),
            item?.transport?.region,
          ].join(' ')}
          color="#0995ED"
        />
        <Item
          title="Тип ТС"
          value={item.transport?.transportType?.name}
        />
        <Item
          title="Страна"
          value={item.transport?.country?.name}
        />
        <TransportDocuments transportId={item?.transport?.id} />
        <div className={styles.actions}>
          <EditNewIcon
            onClick={handleOpenModal}
            className={styles.btnEdit}
          />
          <DeleteTransportBtn
            transportId={item?.transport?.id}
            clientId={tenant?.id}
            addressId={addressId}
            companyId={companyId}
            transport={item?.transport}
            onSuccess={onSuccess}
          />
        </div>
      </div>

      {hasPermits &&
        item?.accessInformation?.map((item) => (
          <div
            className={styles.gridBoxBottom}
            key={item.permit.id}
          >
            <Item
              title="Тип"
              value={item.permit?.transportPermitType?.name}
            />
            <Item
              title="Статус"
              value={item.permit?.permitStatus?.name}
            />
            <Item
              title="Срок"
              value={
                item.permit?.transportPermitType?.id === permitConstants.PERMANENT_PASS
                  ? 'Бессрочный'
                  : moment(item.permit.expireAt).format('DD.MM.YYYY')
              }
              styleContent={{ opacity: 0.6, fontWeight: 400 }}
            />
            <Item
              title="Заявитель"
              value={
                item.clientFio || item.clientName || 'Нет данных о заявителе'
              }
              styleContent={{ opacity: 0.6, fontWeight: 400 }}
            />
          </div>
        ))}
    </div>
  );
};

export default TransportCard;
